export default "__VITE_ASSET__8a8848b0__"